import { rawColors } from "@magicbi/ui-library";

/** Solid accents a categorical badge can take, with white initials on top. */
export const CATEGORICAL_FILLS: readonly string[] = [
  rawColors.accent.purple,
  rawColors.accent.turquoise,
  rawColors.accent.green500,
  rawColors.accent.peach,
  rawColors.accent.artifactBlue,
  rawColors.accent.dataStoryPurple,
];

/** A stable colour for a seed: the same text always gives the same one. */
export const categoricalFill = (seed: string): string => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return CATEGORICAL_FILLS[hash % CATEGORICAL_FILLS.length]!;
};
